import React from 'react';
import './Navbar.css';
import GithubLogo from '../assets/images/GitHub-Mark-Light-64px.png';
// import TwitterLogo from '../assets/images/Twitter-logo.png'
import LinkedInLogo from '../assets/images/LinkedIn_logo_initials.png';
import GmailLogo from '../assets/images/Gmail_Logo_32px.png'
import { animated, useSpring } from 'react-spring';

export default function Navbar(){
    const underscoreAnimation = useSpring({
        loop: true,
        from: { opacity: 0},
        to: { opacity: 1},
        config: { duration: 1000},
    });

    return(
        <nav className="nav">
            <div className="nav-text-container">
                <h1 className="nav-text"><font className="nav-text-sign">&nbsp;[</font>FionnCL :<font className="nav-text-sign"> ~]</font> $ &nbsp;</h1>
                 <b><animated.h1 style={underscoreAnimation} className="nav-text">_</animated.h1></b>
            </div>
            <div className="social-media-container">
                <a href="https://github.com/FionnCL" target="_blank" rel="noreferrer noopener"><img className="logo" src={GithubLogo} alt="Github Account"/></a>
                {/* <a href="https://twitter.com/cl_fionn" target="_blank" rel="noreferrer noopener"><img className="logo twitter" src={TwitterLogo} alt="Twitter Account"/></a> */}
                <a href="https://www.linkedin.com/in/fionn-camacho-lenihan-12699a230" target="_blank" rel="noreferrer noopener"><img className="logo" src={LinkedInLogo} alt="LinkedIn Account"/></a>
                <a href="mailto:camacholenihanfionn@gmail.com" target="_blank" rel="noreferrer noopener"><img className="logo gmail" src={GmailLogo} alt="Gmail Account"/></a>
            </div>
        </nav>
    );
};
